const deleteWorkout = () => {};

export default deleteWorkout;
